import modelsResolver from 'utils/api/models/utils/modelsResolver';
import { AmountPerMonth } from 'utils/api/models/bills/amountPerMonth';

interface IInvoiceAmountsPerMonth {
	amount: number;
	timePeriod: string;
}

// TODO: change invoiceStatus invoiceType to proper types instead of string

export interface IInvoice {
	invoiceNo: string;
	invoiceDate: string;
	dueDate: string;
	invoiceAmount: number;
	invoiceStatus: string; // types 'closed' ...
	invoiceType: string; // types "multiple" ...
	payment: number;
	adjustment: number;
	balanceDue: number;
	disputeAmount: number;
	outstandingAmount: number;
}

export interface IBillData {
	accountId: string;
	billingAccountName: string;
	billingId: string;
	invoiceAmountsPerMonth?: IInvoiceAmountsPerMonth[];
	invoices?: IInvoice[];
}

export type BillsHistoryForAccount = {
	accountsInvoiceAmountsPerMonth: any;
	accountsChargeAmountsPerMonth: any;
	_totalInvoiceAmountsPerMonth: any;
	totalInvoiceAmountsPerMonth: AmountPerMonth[];
	_totalChargeAmountsPerMonth: any;
	totalChargeAmountsPerMonth: AmountPerMonth[];
	toDate: string;
	fromDate: string;
	billsData: Array<IBillData>;
};

const model: types.models.InputModel = {
	accountsInvoiceAmountsPerMonth: ['response.getBillsHistoryForAccountsResponse.accountsInvoiceAmountsPerMonth', []],
	accountsChargeAmountsPerMonth: ['response.getBillsHistoryForAccountsResponse.accountsChargeAmountsPerMonth', []],
	_totalInvoiceAmountsPerMonth: ['response.getBillsHistoryForAccountsResponse.totalInvoiceAmountsPerMonth', []],
	toDate: 'response.getBillsHistoryForAccountsResponse.toDate',
	fromDate: 'response.getBillsHistoryForAccountsResponse.fromDate',
	billsData: ['response.getBillsHistoryForAccountsResponse.billsData', []],
	_totalChargeAmountsPerMonth: ['response.getBillsHistoryForAccountsResponse.totalChargeAmountsPerMonth', []],
	totalInvoiceAmountsPerMonth: (model: BillsHistoryForAccount) => {
		if (model._totalInvoiceAmountsPerMonth) {
			return model._totalInvoiceAmountsPerMonth.map((amount: any) => modelsResolver(amount, 'amountPerMonth'));
		}
		return [];
	},
	totalChargeAmountsPerMonth: (model: BillsHistoryForAccount) => {
		if (model._totalChargeAmountsPerMonth) {
			return model._totalChargeAmountsPerMonth.map((amount: any) => modelsResolver(amount, 'amountPerMonth'));
		}
		return [];
	},
};

export default model;
